import { animate, onScroll } from 'animejs';

/**
 * Anime JS
 */
(() => {
  animate('.anim-custom .hero-static .image-wrapper', {
    scale: [1, 1.2],
    autoplay: onScroll({
      target: '.hero-static',
      enter: 'top -120px',
      leave: 'top 100%',
      sync: 0.75,
    }),
  });
})();
